import {defineStore} from "pinia";
import type {VNode} from "vue";
import {AppDialogAppAlertDialog, AppDialogAppConfirmDialog, AppDialog} from "#components";

interface DialogInfo {
    idx: number;
    vNode: VNode;
    type?: string;
}

export const useDialogStore = defineStore("DialogStore", {
    state: () => ({
        dialogInfoList: [] as DialogInfo[],
    }),
    actions: {
        /**
         * @description idx 번째 다이얼로그를 삭제합니다.
         * @param idx 다이얼로그 인덱스
         */
        closeDialog(idx: number) {
            this.$state.dialogInfoList.splice(idx, 1);
        },

        /**
         * @description 다이얼로그를 띄웁니다.
         * @param vNode 다이얼로그 VNode
         * @param option
         */
        showDialog(vNode: VNode, option:Object = {}) {
            const idx = this.$state.dialogInfoList.length;
            this.$state.dialogInfoList.push({
                idx,
                vNode: <AppDialog option={option} onClose={() => this.closeDialog(idx)}>{{content: () => vNode}}</AppDialog>,
            });
        },
        showAlertDialog(text: string | VNode, closeEvent: Function = () => {
        }, option:Object = {closeLabel:'닫기'}) {
            const idx = this.$state.dialogInfoList.length;
            this.$state.dialogInfoList.push({
                idx,
                vNode: (
                    <AppDialogAppAlertDialog
                        option={option}
                        onClose={() => {
                            this.closeDialog(idx);
                            closeEvent();
                        }}
                    >
                        {{content: () => text}}
                    </AppDialogAppAlertDialog>
                ),
            });
        },

        showConfirmDialog(text: string | VNode, submitButtonString: string, options?: Object) {
            return new Promise((resolve, reject) => {
                const idx = this.$state.dialogInfoList.length;
                this.$state.dialogInfoList.push({
                    idx,
                    vNode: (
                        <AppDialogAppConfirmDialog
                            submitButtonString={submitButtonString}
                            options={options}
                            onClose={() => {
                                this.closeDialog(idx);
                                resolve(false);
                            }}
                            onSubmit={() => {
                                this.closeDialog(idx);
                                resolve(true);
                            }}
                        >
                            {{content: () => text}}
                        </AppDialogAppConfirmDialog>
                    ),
                });
            });
        },
    },
});
